import Vue from 'vue'
import App from './App.vue'

import {router} from './router'
App.router = router

import VModal from 'vue-js-modal'
Vue.use(VModal)

import { icons } from './icons'
import { util } from './util'
import { store, mutations, actions } from './store'
import VueGlobalVar from 'vue-global-var'
Vue.use(VueGlobalVar, {
  globals: {
    $icons: icons,
    $util: util,
    $store: store,
    $commit: mutations,
    $dispatch: actions
  }
})

Vue.config.productionTip = false
Vue.config.devtools = true

addEventListener('DOMContentLoaded', () => {
  const elem = document.getElementById('vue-provider-directory')
  if (elem) {
    try {
      const config = JSON.parse(
        document.getElementById('provider-directory-config-' + elem.dataset.id).innerHTML
      )

      actions.setup(config)

      const vueData = Object.assign({
        el: elem
      }, App)
      new Vue(vueData)
    } catch (e) {
      console.log(e)
    }
  }
})